import { FlexPool } from 'hq/services/flex-pool-service.types';
import { z } from 'zod';

export const employeeObjectSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  infix: z.string().optional().nullable(),
  email: z.string(),
  phone: z.string().nullable(),
  profilePictureUrl: z.string().optional(),
  state: z.string().optional(),
  isOnboarded: z.boolean(),
  location: z
    .object({
      address: z.string(),
      city: z.string().optional().nullable(),
      country: z.string().optional().nullable(),
      houseNumber: z.string().optional().nullable(),
      postalCode: z.string().optional().nullable(),
      street: z.string().optional().nullable(),
    })
    .optional(),
  allowResendTemporaryPassword: z.boolean().optional(),
});

export const employeesInfiniteResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  previousPage: z.number().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  items: z.array(employeeObjectSchema),
});

export type EmployeePayload = {
  email: string;
  firstName: string;
  infix?: string;
  lastName: string;
};

export type EmployeeUpdatePayload = {
  firstName: string;
  infix?: string;
  lastName: string;
  employeeFlexPools: FlexPool[];
};

export type EmployeesInfiniteResponse = z.infer<typeof employeesInfiniteResponseSchema>;
export type EmployeeResponse = z.infer<typeof employeeObjectSchema>;
